import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className={`border-b border-brand-brown/10 last:border-0 overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-brand-coral/5 rounded-xl border-transparent' : ''}`} data-id="element-20">
      <button onClick={onClick} className="w-full flex items-center justify-between py-6 px-4 md:px-6 text-left focus:outline-none" aria-expanded={isOpen} data-id="element-21">
        <span className={`text-lg font-bold pr-8 ${isOpen ? 'text-brand-coral' : 'text-brand-brown'}`} data-id="element-22">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'text-brand-coral rotate-180' : 'text-brand-brown/40'}`} data-id="element-23" />
      </button>
      <AnimatePresence data-id="element-24">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-25">
            <div className="px-4 md:px-6 pb-6 text-brand-brown/80 text-lg leading-relaxed" data-id="element-26">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Los ingredientes son caros?',
    answer: 'No, aprovechamos las marcas blancas de los supermercados líderes en USA (como Target, Walmart y Aldi) para mantener el presupuesto bajo control.'
  }, {
    question: "¿Sirve para niños 'picky eaters'?",
    answer: 'Sí, el sistema modular permite ajustar los ingredientes a sus gustos específicos. Tú eliges qué poner en cada categoría (Base, Músculo, Escudo, Premio).'
  }, {
    question: '¿Es una suscripción?',
    answer: 'No, es un pago único de $19 por acceso de por vida a todo el material.'
  }, {
    question: '¿Necesito cocinar mucho?',
    answer: 'No, es un sistema de ENSAMBLAJE, la mayoría de los pasos requieren preparación mínima o utilizan sobras inteligentes.'
  }, {
    question: "¿Qué pasa si mi escuela es 'Nut-Free'?",
    answer: 'Todas nuestras opciones cumplen con las normativas de seguridad escolar de EE.UU., asegurando que las loncheras sean seguras para todos.'
  }];
  return <section className="py-24 bg-white" data-id="element-27">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="text-center mb-12" data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-brown mb-4" data-id="element-30">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-brand-brown/10 p-2" data-id="element-31">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.question} answer={faq.answer} isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-32" />)}
        </div>
      </div>
    </section>;
}